import { Box, Switch } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { Fragment, useContext } from "react";
import { Plus } from "react-feather";
import {
  Card,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
  Table,
} from "reactstrap";
import { Style, USER_MASTER } from "../../constant";
import DataNotFound from "../../DataNoteFound/DataNotFound";
import Breadcrumbs from "../../layout/breadcrumb";
import TableMenuItem from "../../utils/TableMenuItem";
import UserContext from "../../context/userContext";
import TableSkeleton from "../../loader/TableSkeleton";
import OrganizationContext from "../../context/OrganizationContext/OrganizationContext";
import { MuiTabelStyle } from "../../utils/helper";

const UserItem = (props) => {
  const {
    editHandle,
    showHandle,
    deleteHandle,
    statusHandle,
    sorting,
    AddModel,
    setPage,
    setPageSize,
    pageSize,
    page,
    record,
  } = props;
  const { data, filter, setFilter } = useContext(UserContext);
  const { responseLoader } = useContext(OrganizationContext);
  const defaultColumns = [
    {
      flex: 0.1,
      minWidth: 200,
      field: "name",
      headerName: "Name",
      renderCell: (params) => (params.row.name ? params.row.name : "--"),
    },
    {
      flex: 0.1,
      minWidth: 250,
      field: "email",
      headerName: "Email",
      renderCell: (params) => (params.row.email ? params.row.email : "--"),
    },
    {
      flex: 0.1,
      minWidth: 150,
      field: "phone",
      headerName: "Phone",
      renderCell: (params) => (params.row.phone ? params.row.phone : "--"),
    },
    {
      flex: 0.1,
      minWidth: 150,
      field: "roleId",
      headerName: "Role",
      renderCell: (params) => {
        switch (params.row.roleId) {
          case 1: return "Super Admin";
          case 2: return "Org Admin";
          case 3: return "Temple Admin";
          case 4: return "Cashier";
          case 5: return "Accountant";
          default: return "--";
        }
      },
    },
    {
      flex: 0.1,
      minWidth: 120,
      field: "isActive",
      headerName: "Status",
      renderCell: (params) => (
        <Switch
          checked={Number(params.row.isActive) === 1}
          onChange={(e) => statusHandle(params.row.userId, e.target.checked ? 1 : 0)}
          color="primary"
        />
      ),
    },
    {
        flex: 0.1,
        minWidth: 150,
        field: "createdAt",
        headerName: "Created At",
        renderCell: (params) => params.row.createdAt ? new Date(params.row.createdAt).toLocaleDateString() : "--",
      },
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      renderCell: (params) => (
        <>
          <TableMenuItem
            params={params}
            editHandle={editHandle}
            showHandle={showHandle}
            deleteHandle={deleteHandle}
          />
        </>
      ),
    },
  ];

  return (
    <>
      <Fragment>
        <Breadcrumbs parent={USER_MASTER.USER_MASTER_PARENT} />
        <Container fluid={true}>
          <Row>
            <Col sm="12">
              <Card>
                <CardHeader
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <h3>{USER_MASTER.USER_MASTER_PARENT}</h3>
                  <div
                    aria-label="add"
                    className="btn btn-primary"
                    onClick={AddModel}
                    style={Style}
                  >
                    <Plus />
                  </div>
                </CardHeader>
                <Table>
                  <thead>
                    <tr>
                      <th>
                        <Row>
                          <Col md="3 mb-2">
                            <Input
                              className="form-control no-outline"
                              type="text"
                              placeholder="User Search..."
                              value={filter}
                              onChange={(e) => setFilter(e.target.value)}
                            />
                          </Col>
                        </Row>
                      </th>
                    </tr>
                  </thead>
                </Table>
                <Box
                  sx={{
                    "& .even": {
                      backgroundColor: "#f1f1f1",
                    },
                    "& .odd": {
                      backgroundColor: "white",
                    },
                  }}
                >
                  {responseLoader === true ? (
                    <TableSkeleton />
                  ) : data && data.length ? (
                    <DataGrid
                      sx={MuiTabelStyle}
                      autoHeight
                      pagination
                      rows={data}
                      rowCount={record}
                      pageSize={pageSize}
                      getRowId={(row) => row.userId}
                      columns={defaultColumns}
                      page={page - 1}
                      rowsPerPageOptions={[7, 10, 25, 50]}
                      onPageSizeChange={(newPageSize) =>
                        setPageSize(newPageSize)
                      }
                      onPageChange={(newPageNo) => setPage(newPageNo + 1)}
                      paginationMode="server"
                      disableSelectionOnClick
                      checkboxSelection={false}
                      sortingMode="server"
                      onSortModelChange={sorting}
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0
                          ? "even"
                          : "odd"
                      }
                    />
                  ) : (
                    <DataNotFound />
                  )}
                </Box>
              </Card>
            </Col>
          </Row>
        </Container>
      </Fragment>
    </>
  );
};

export default UserItem;
